import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../Shared/Buttons/Button';
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';

import 'react-toastify/dist/ReactToastify.css';
function ConfigurationPage(props) {

    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <div className="page-container page-container--narrow">
            <div className={classes.linkContainer}>
                <div className={classes.boxStyle}>
                    <div className={classes.menuItem}>
                        {t('configurationPage.createDropdownDesc')}
                    </div>
                    <Link to='/createdropdown' style={{ textDecoration: 'none' }} className={classes.link}>
                        <Button className={classes.linkButton}>{props.content}{t('nav.createDropdown')}</Button>
                    </Link>
                </div>
                <div className={classes.boxStyle}>
                    <div className={classes.menuItem}>
                        {t('configurationPage.manageDropdownsDesc')}
                    </div>
                    <Link to='/dropdownoverview' style={{ textDecoration: 'none' }} className={classes.link}>
                        <Button className={classes.linkButton}>{props.content}{t('configurationPage.manageDropdowns')}</Button>
                    </Link>
                </div>
                <div className={classes.boxStyle}>
                    <div className={classes.menuItem}>
                        {t('configurationPage.createApiDesc')}
                    </div>
                    <Link to='/createapi' style={{ textDecoration: 'none' }} className={classes.link}>
                        <Button className={classes.linkButton}>{props.content}{t('nav.createApi')}</Button>
                    </Link>
                </div>
                <div className={classes.boxStyle}>
                    <div className={classes.menuItem}>
                        {t('configurationPage.manageApisDesc')}
                    </div>
                    <Link to='/externalapioverview' style={{ textDecoration: 'none' }} className={classes.link}>
                        <Button className={classes.linkButton}>{props.content}{t('configurationPage.manageApis')}</Button>
                    </Link>
                </div>
                <div className={classes.boxStyle}>
                    <div className={classes.menuItem}>
                        {t('configurationPage.manageFlowBoxDesc')}
                    </div>
                    <Link to='/flowboxoverview' style={{ textDecoration: 'none' }} className={classes.link}>
                        <Button className={classes.linkButton}>{props.content}{t('configurationPage.manageFlowBox')}</Button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default ConfigurationPage;
const useStyles = makeStyles((theme) => ({
    linkContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        marginTop: "160px",
    },
    boxStyle: {
        display: "flex",
        justifyContent: "space-between",
        background: "#FFFFFF",
        border: "1px solid var(--color-border-light)",
        borderRadius: "8px",
        padding: "16px",
        paddingLeft: '24px',
    },
    menuItem: {
        color: '#1D3557',

        [theme.breakpoints.down('sm')]: {
            fontSize: '1rem',
            width: '50% !important',
        },
        [theme.breakpoints.up('sm')]: {
            width: '100% !important',
            fontSize: '1.2rem',
        },
        display: "flex",
        alignItems: "center",
    },
    link: {
        [theme.breakpoints.down('sm')]: {
            marginLeft: '5%',
            width: '50% !important',
            minWidth: '50% !important',
        },
    },
    linkButton: {
        minWidth: '200px',
    },
}));